/**
 * Adaptador de compatibilidad para las vistas actuales del Core.
 *
 * La implementación de RenderBase ya no vive en el Core. Durante initRender(),
 * app.js carga una instancia mediante ptzaRender.builder() y conecta el
 * prototipo de esa implementación externa a esta clase puente.
 *
 * Esto permite conservar sin cambios las clases existentes que todavía hacen
 * `extends RenderBase` mientras Builder se carga de forma dinámica desde
 * ptzaRender.
 */
export class RenderBase {}
